import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

import { StatValue } from './StatValue'

interface MetricsCardProps {
  totals: { posts: number; following: number; followers: number }
  stats: { redFlagsDetected: number }
}

export function MetricsCard({ totals, stats }: MetricsCardProps) {
  const { t } = useTranslation()
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="rounded-2xl backdrop-blur-xl p-3 bg-baseColorHighlight divide-y divide-neutralColor30">
        <Row
          label={t('dashboard.newSearch.generatingReport.metrics.totalPosts')}
          value={
            <StatValue
              value={totals.posts}
              className="text-base font-medium text-neutralColor tabular-nums"
            />
          }
        />

        <Row
          label={t(
            'dashboard.newSearch.generatingReport.metrics.redFlagsDetected',
          )}
          value={
            <StatValue
              value={stats.redFlagsDetected}
              className="text-base font-medium tabular-nums text-dynamicRed"
            />
          }
        />

        <Row
          label={t(
            'dashboard.newSearch.generatingReport.metrics.totalFollowers',
          )}
          value={
            <StatValue
              value={totals.followers}
              className="text-base font-medium text-neutralColor tabular-nums"
            />
          }
        />

        <Row
          label={t(
            'dashboard.newSearch.generatingReport.metrics.totalFollowing',
          )}
          value={
            <StatValue
              value={totals.following}
              className="text-base font-medium text-neutralColor tabular-nums"
            />
          }
        />
      </div>
    </motion.div>
  )
}

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex items-center justify-between py-3">
      <span className="text-base text-neutralColor60">{label}</span>
      {value}
    </div>
  )
}
